<template>
    <pm-custom-dialog v-if="visible" v-model="visible">


        <div style="background: url(/images/dc_4in1_150_150.png) center center / contain no-repeat rgb(255, 255, 255); margin: 20px 0px 20px 0; width: 100%; height: 70px;"></div>

        <div style="margin-bottom: 16px; text-align: center;">
            <h2 style="line-height: 1.2; font-weight: 600; text-shadow: 0.5px 0.5px 0 #000;">Welcome, Doctor</h2>
        </div>

        <div style="line-height: 1.3; font-size: 14px; margin-bottom: 8px; padding: 0 30px; text-align: center;">
            <br/>
            Here you will find tips on how to get the most out of using DentiCalc. For now, feel free to explore all the possibilities of DentiCalc.
            <br/>
            <br/>
            <div style="display: flex; margin: 18px 0; text-align: left; align-items: center; justify-content: flex-start;">
                <span style="flex-shrink: 0; background-color: green; padding: 3px; border-radius: 50%; margin-right: 12px; "><mdi size="18" style="color: white;">mdiCheck</mdi></span>
                <span>
                    <b style="font-weight: 600;">Create plans and personalized animations</b> in seconds with SMART
                </span>
            </div>

            <div style="display: flex; margin: 18px 0; text-align: left; align-items: center; justify-content: flex-start;">
                <span style="flex-shrink: 0; background-color: green; padding: 3px; border-radius: 50%; margin-right: 12px; "><mdi size="18" style="color: white;">mdiCheck</mdi></span>
                <span>
                    <b style="font-weight: 600;">Explain treatments</b> with PHOTOS and state-of-the-arts VIDEOS
                </span>
            </div>

            <div style="display: flex; margin: 18px 0; text-align: left; align-items: center; justify-content: flex-start;">
                <span style="flex-shrink: 0; background-color: green; padding: 3px; border-radius: 50%; margin-right: 12px; "><mdi size="18" style="color: white;">mdiCheck</mdi></span>
                <span>
                    <b style="font-weight: 600;">Give prices</b> for your patient with the CALCULATOR
                </span>
            </div>

            -<br/><br/>
            Don't forget to set your own prices, language and currency in the settings. If you need help, feel free to contact us. We are eager to help.
        </div>
    </pm-custom-dialog>
</template>
<script>
import PmCustomDialog from "./base-dialog.vue";
export default {
    components: {
        PmCustomDialog
    },
    data: () => ({
        visible: false,
    }),
    created() {

    },
    methods: {
        show() {
            this.visible = true;
        },
        close() {
            this.visible = false;
            this.$emit('close');
        },
    }
}
</script>
